import { Timestamp } from 'firebase/firestore';

export interface DriveFile {
  id: string;
  userId: string;
  fileName: string;
  originalName: string;
  fileSize: number;
  mimeType: string;
  storagePath: string;
  folder: DriveFolder;
  customFolder?: string | null;
  uploadedAt: Timestamp;
  uploadedBy: string;
  downloadURL?: string;
}

export interface DriveStats {
  userId: string;
  totalSize: number;
  fileCount: number;
  lastUpdated: Timestamp;
}

export type DriveFolder = 'documents' | 'cv-versions' | 'cover-letters' | 'certificates' | 'custom';

export interface UploadProgress {
  fileName: string;
  progress: number;
  status: 'uploading' | 'completed' | 'error';
  error?: string;
}

export interface DriveFilters {
  folder?: DriveFolder;
  search?: string;
  sortBy?: 'name' | 'date' | 'size';
  sortOrder?: 'asc' | 'desc';
}

export const DRIVE_FOLDERS: { value: DriveFolder; label: string; icon: string }[] = [
  { value: 'documents', label: 'Documenti', icon: '📄' },
  { value: 'cv-versions', label: 'Versioni CV', icon: '📋' },
  { value: 'cover-letters', label: 'Lettere di Presentazione', icon: '✉️' },
  { value: 'certificates', label: 'Certificati', icon: '🏆' },
  { value: 'custom', label: 'Cartelle Personalizzate', icon: '📁' },
];

export const SUPPORTED_FILE_TYPES = {
  'application/pdf': 'PDF',
  'application/msword': 'DOC',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
  'image/jpeg': 'JPG',
  'image/png': 'PNG',
  'image/gif': 'GIF',
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const MAX_TOTAL_SIZE = 50 * 1024 * 1024; // 50MB

export const getFileIcon = (mimeType: string): string => {
  switch (mimeType) {
    case 'application/pdf':
      return '📄';
    case 'application/msword':
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      return '📝';
    case 'image/jpeg':
    case 'image/png':
    case 'image/gif':
      return '🖼️';
    default:
      return '📎';
  }
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

export const sanitizeFileName = (fileName: string): string => {
  return fileName
    .replace(/[^a-zA-Z0-9.-]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '');
}; 